export default __webpack_public_path__ + "static/media/INFORMATICA COMPLETO.9844cbec.pdf";